//
import { ModuleLayout } from "@/components/reusable_components/next"

//
import CustomerReceivablePaymentListView from "@/views/POS/PosCustomerReceivablePayment/CustomerReceivablePaymentList"

//
export default {
    path: "pos_customer_receivable_payment", 
    component: ModuleLayout,
    children: [
        {
            path: "", 
            name: "customer-receivable-payment-list",
            component: CustomerReceivablePaymentListView,
        }
    ],
    meta: {
        title: "Registros de pago de deudas",
    }
}